import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import styled from "styled-components"
import { useScrollLock } from "../../../hooks/useScrollLock"
import { useLocation } from "react-router-dom"
import { showModal } from "../../../features/modal/modalSlice"
import PageTopTitle from "../../shared/PageTopTitle"
import Btn from "../../shared/button/Btn"
import { deleteRoadRoute, deleteRoadRouteThirdLocation } from "../../../features/admin3/admin3Slice"

const ModalContainer = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 26;

    .modal{
        width: 500px;
        height: auto;
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.mainBgColor};
        border: 1px solid;
        border-color: ${({ theme }) => theme.mainBorderColor};
        padding-top: 20px;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        align-items: center;
        overflow: auto;
        .content{
            margin-block: 20px;
            padding: 0 30px;
            display: flex;
            flex-direction: column;
            height: 100%;
            width: 100%;
           .btn-container{
            display: flex;
            flex-direction: column;
            gap: 20px;
           }
        }

    }
`

const RoadRouteOptionsModal = () => {

    const dispatch = useDispatch()
    const location = useLocation()
    const {modalLocation } = useSelector(state => state.modal)
    const { lockScroll, unlockScroll } = useScrollLock();
    const {selectedInspectionStationRoute} = useSelector((state) => state.admin3)


       //! bu modal açıldığnda ekran ı lock lamak için
    useEffect(() => {
        lockScroll()

        return () => {
            unlockScroll()
        }
    }, [lockScroll, unlockScroll])

    //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
    useEffect(() => {
        if (location.pathname !== modalLocation) {
            dispatch(showModal(null))
        }
    }, [dispatch, location.pathname, modalLocation])

  return (
    <ModalContainer onClick={()=> dispatch(showModal(null))}>
        <div className="modal" onClick={(e) => e.stopPropagation()}>
            <PageTopTitle title={"İstasyon"}/>
            <div className="content">
                <div className="btn-container">
                    <Btn handleClick={() => dispatch(showModal("createThirdRoadRoute"))} bgColor="transparent" borderColor="#E85446" color="#E85446">3. Konum Ekle</Btn>
                    <Btn handleClick={() => dispatch(deleteRoadRouteThirdLocation(selectedInspectionStationRoute.id))} bgColor="transparent" borderColor="#E85446" color="#E85446">3. Konum Sil</Btn>
                    <Btn handleClick={() => dispatch(showModal("updateRoadRoute"))} bgColor="transparent" borderColor="#E85446" color="#E85446">Güncelle</Btn>
                    <Btn handleClick={() => dispatch(deleteRoadRoute(selectedInspectionStationRoute.id))} bgColor="transparent" borderColor="#E85446" color="#E85446">Sil</Btn>
                    <Btn handleClick={() => dispatch(showModal(null))} bgColor="transparent" borderColor="#E85446" color="#E85446">Kapat</Btn>
                </div>
            </div>
        </div>
    </ModalContainer>
  )
}

export default RoadRouteOptionsModal